






















































import { computed, defineComponent, PropType } from '@vue/composition-api';
import { ErrorObject, Validation } from '@vuelidate/core';
import useLowercased from '@/composables/useLowercased';

export default defineComponent({
  emits: ['keydown'],
  props: {
    type: {
      type: String,
      default: 'input'
    },
    v: {
      type: Object as PropType<Validation>,
      required: false
    },
    label: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    value: {
      type: String,
      required: false
    },
    debounce: {
      type: Number,
      default: 0
    },
    description: {
      type: String,
      required: false
    },
    errors: {
      type: Array as PropType<ErrorObject[]>,
      default: () => []
    },
    warning: {
      type: String,
      required: false
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 3
    },
    maxlength: {
      type: Number,
      default: undefined
    }
  },
  setup(props, { emit }) {
    const keydown = (e: any) => {
      emit('keydown', e);
    };

    function setMaxLength(e: any) {
      if (props.maxlength) {
        return String(e).substring(0, props.maxlength);
      }
      return e;
    }

    return {
      useLowercased,
      setMaxLength,
      input: computed<string | undefined>({
        get(): string | undefined {
          return props.v ? (props.v.$model as string) : props.value;
        },
        set(newValue: string | undefined): void {
          props.v ? (props.v.$model = newValue) : emit('input', newValue);
        }
      }),
      mErrors: computed(() => (props.v ? props.v.$errors : props.errors)),
      keydown
    };
  }
});
